import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import cookie from 'vue-cookies'

import AdminLayout from "../views/AdminLayout.vue"

Vue.use(VueRouter)

const requireAuth = (from, to, next) => {
  const isAuthenticated = false

  let token = cookie.get('token');
  if (token != "" && token != undefined) return next()
  next('/login?returnPath=me')
}


const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    beforeEnter: requireAuth,
  },
  {
    path: '/render',
    name: 'Render',
    component: () => import(/* webpackChunkName: "about" */ '../views/Render.vue'),
    beforeEnter: requireAuth,
  },

  {
    path: '/profile',
    name: 'Profile',
    component: () => import(/* webpackChunkName: "about" */ '../views/Profile.vue'),
    beforeEnter: requireAuth,

  },

  {
    path: '/workspace',
    name: 'Workspace',
    component: () => import(/* webpackChunkName: "about" */ '../views/Workspace.vue')
  },
  {
    path: '/task1',
    name: 'Task1',
    component: () => import(/* webpackChunkName: "about" */ '../views/Task1.vue')
  },
  {
    path: '/task2',
    name: 'Task2',
    component: () => import(/* webpackChunkName: "about" */ '../views/Task2.vue')
  },
  {
    path: '/task3',
    name: 'Task3',
    component: () => import(/* webpackChunkName: "about" */ '../views/Task3.vue')
  },
  {
    path: '/task4',
    name: 'Task4',
    component: () => import(/* webpackChunkName: "about" */ '../views/Task4.vue')
  },
  {
    path: '/studyroom',
    name: 'Studyroom',
    component: () => import(/* webpackChunkName: "about" */ '../views/Studyroom.vue')
  },

  {
    path: '/page',
    name: 'Page',
    component: () => import(/* webpackChunkName: "about" */ '../views/Page.vue')
  },

  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "about" */ '../views/login.vue')
  },
  {
    path: '/admin',
    component: AdminLayout,
    children: [
      {
        path: 'labs/list',
        name: 'labsList',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/labs/list.vue')
      },
      {
        path: 'labs/imageeditor',
        name: 'labsImageEditor',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/labs/imageeditor.vue')
      },
      {
        path: 'labs/print',
        name: 'labsPrint',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/labs/print.vue')
      },
      {
        path: 'labs/swipper',
        name: 'labsSwipper',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/labs/swipper.vue')
      },




      {
        path: 'book/list',
        name: 'bookList',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/book/BookList.vue')
      },
      {
        path: 'book/unitmgr',
        name: 'bookUnitMgr',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/book/UnitMgr.vue')
      },

      {
        path: 'book/form',
        name: 'bookForm',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/book/BookForm.vue')
      },
      {
        path: 'question/list',
        name: 'questionList',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/question/QuestionList.vue')
      },
      {
        path: 'dummy',
        name: 'Dummy',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/book/list.vue')
      },
      {
        path: 'intent/list',
        name: 'intentList',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/intent/list.vue')
      },
      {
        path: 'intent/write',
        name: 'intentWrite',
        component: () => import(/* webpackChunkName: "about" */ '../views/admin/intent/write.vue')
      },


    ],
    beforeEnter: requireAuth,
  },



]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
